import { render } from "./Termination.vue?vue&type=template&id=31e1090f"
import script from "./Termination.vue?vue&type=script&lang=js"
export * from "./Termination.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__